import { Scene } from 'scrollmagic'
import { TweenLite, Power2 } from 'gsap'
import scrollController from './scroll-controller'
import UI from './utils/UI'

UI({
  component: '.js-animateOnScroll'
}, ({ component }) => {
  const key = component.dataset.animation || 'fadeInFromBottom'
  const scene = new Scene({ triggerHook: 'onEnter', triggerElement: component, offset: 80 })
  scene.setTween(getTween(component, key)).addTo(scrollController)
})

function getTween (component, key) {
  switch (key) {
    case 'fadeInFromBottom':
      return TweenLite.fromTo(component, 0.25, { opacity: 0, y: 20 }, { opacity: 1, y: 0, ease: Power2.easeInOut })
    case 'fadeInFromLeft':
      return TweenLite.fromTo(component, 0.25, { opacity: 0, x: -20 }, { opacity: 1, x: 0, ease: Power2.easeInOut })
    case 'fadeInFromRight':
      return TweenLite.fromTo(component, 0.25, { opacity: 0, x: 20 }, { opacity: 1, x: 0, ease: Power2.easeInOut })
    case 'scaleUp':
      return TweenLite.fromTo(component, 0.15, { scale: 0, opacity: 1 }, { scale: 1, opacity: 1, ease: Power2.easeInOut })
  }
}
